import React, {ReactElement} from 'react';
import icon from '@assets/images/medops/Referral.png';
const ReferralIconImage = (props: any): ReactElement => {
  return <img src={icon} {...props} />;
};
const ReferralIcon = React.memo(ReferralIconImage);
export default React.memo(ReferralIcon);
